import { render, staticRenderFns } from "./IdcEdit.vue?vue&type=template&id=7663b068&"
import script from "./IdcEdit.vue?vue&type=script&lang=js&"
export * from "./IdcEdit.vue?vue&type=script&lang=js&"
import style0 from "./IdcEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports